import { CampaignFormData } from '@tt4b/ttam-enums';
import { StateEnum, useAdgroupListApi, useRequest, useStore, ValidationError } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';

import { i18n } from './../../../i18n';
import { getRouteQuery } from '@tt4b/ttam-utils';

export function useDataSource(opt: { campaignId: Ref<string> }) {
  const { state } = useStore();
  const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
  const params = computed(() => ({
    params: {
      campaign_id: opt.campaignId.value,
      aadvid: aadvid.value,
      req_src: 'ad_creation',
    },
  }));
  const { data, isLoading, run, error } = useRequest(useAdgroupListApi, params, {
    manual: true,
  });

  return {
    data,
    loading: isLoading,
    run,
    error,
  };
}

export function usePropsCampaignId(opt: { campaignData: Ref<CampaignFormData> }) {
  const campaignId = computed(
    () => opt.campaignData.value.campaignId || getRouteQuery(location.href, 'campaign_id') || ''
  );
  return {
    campaignId,
  };
}

export function usePropsSelectDisabled(opt: { campaignId: Ref<string> }) {
  return {
    disabled: computed(() => !opt.campaignId.value),
  };
}
